<template>
  <v-card class="pa-6" outlined>
    <div class="d-flex align-center">
      <v-spacer></v-spacer>
      <h2 class="ml-12">{{ isEditing ? 'Atualizar' : 'Nova' }} medição</h2>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close')" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-divider class="mt-2 mb-1 mx-1"></v-divider>

    <v-form ref="form">
      <v-row class="ma-0" dense justify="center">
        <v-col cols="12">
          <label class="label"> Dados da medição </label>
        </v-col>

        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>

        <v-col cols="12" sm="4">
          <label>Padrão</label>
          <v-autocomplete
            v-model="parameter.patternId"
            class="primary-input"
            :items="patterns"
            item-text="name"
            item-value="id"
            outlined
            disabled
            hide-details="auto"
            placeholder="Selecione o padrão"
            append-icon="mdi-chevron-down"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="4">
          <label>Métrica</label>
          <v-text-field
            v-model="parameter.metric.name"
            hide-details="auto"
            disabled
            placeholder="Selecione a métrica"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="4">
          <label>Parâmetro</label>
          <v-text-field
            v-model="parameter.name"
            hide-details="auto"
            disabled
            placeholder="Selecione o parâmetro"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <label>Resolução</label>
          <v-text-field
            v-model="parameter.patternResolution"
            hide-details="auto"
            disabled
            placeholder="Insira a resolução"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <label>Resolução equipamento</label>
          <v-text-field
            v-model="parameter.equipmentResolution"
            hide-details="auto"
            disabled
            placeholder="Insira a resolução do equipamento"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <label>Tolerância</label>
          <v-text-field
            v-model="parameter.tolerance"
            hide-details="auto"
            disabled
            placeholder="Insira a tolerância"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <label>Valor absoluto</label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            v-model="parameter.isAbsoluteValue"
            hide-details="auto"
            item-text="text"
            item-value="value"
            :items="[
              {
                text: 'Valor absoluto',
                value: true,
              },
              {
                text: 'Valor percentual',
                value: false,
              },
            ]"
            disabled
            placeholder="Digite o nome do parâmetro"
            outlined
            class="primary-input"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>

        <v-col cols="12" sm="3">
          <label>Faixa</label>
          <v-text-field
            v-model="range.range"
            hide-details="auto"
            :disabled="loading"
            placeholder="Insira a faixa"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            @change="getInterpolatedData"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <label>K</label>
          <v-text-field
            v-model="range.k"
            hide-details="auto"
            placeholder="Insira o K"
            outlined
            class="primary-input"
            disabled
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <label>Incerteza</label>
          <v-text-field
            v-model="range.uncertainty"
            hide-details="auto"
            placeholder="Insira a incerteza"
            outlined
            class="primary-input"
            disabled
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <label>Tendência</label>
          <v-text-field
            v-model="range.tendency"
            hide-details="auto"
            placeholder="Insira a tendência"
            outlined
            class="primary-input"
            disabled
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>

        <v-col cols="12">
          <label class="label"> Valores </label>
        </v-col>

        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>

        <v-col>
          <label>VL 1</label>
          <v-text-field
            v-model="range.vl1"
            hide-details="auto"
            :disabled="loading"
            placeholder="Inserir"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-text-field>
        </v-col>
        <v-col>
          <label>VL 2</label>
          <v-text-field
            v-model="range.vl2"
            hide-details="auto"
            :disabled="loading"
            placeholder="Inserir"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-text-field>
        </v-col>
        <v-col>
          <label>VL 3</label>
          <v-text-field
            v-model="range.vl3"
            hide-details="auto"
            :disabled="loading"
            placeholder="Inserir"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-text-field>
        </v-col>
        <v-col>
          <label>VL 4</label>
          <v-text-field
            v-model="range.vl4"
            hide-details="auto"
            :disabled="loading"
            placeholder="Inserir"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-text-field>
        </v-col>
        <v-col>
          <label>VL 5</label>
          <v-text-field
            v-model="range.vl5"
            hide-details="auto"
            :disabled="loading"
            placeholder="Inserir"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
      </v-row>
    </v-form>

    <div class="d-flex mt-4">
      <v-btn color="error" depressed @click="$emit('close')">Cancelar</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" class="ma-0" depressed @click="submit">
        Adicionar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'

export default {
  name: 'CalibrationV2ManageRange',

  props: {
    parameter: Object,
    patterns: [],
  },

  data() {
    return {
      loading: false,
      apiService: new ApiService(),
      isEditing: false,
      range: {},
    }
  },

  methods: {
    getInterpolatedData() {
      const model = {
        metricId: this.parameter.metricId,
        patternId: this.parameter.patternId,
        range: this.range.range.toString().replace(',', '.'),
      }

      this.apiService
        .post('calibration/v2/template/parameter/interpolate', model)
        .then((response) => {
          console.log(response)
          this.range = { ...this.range, ...response.content }
        })
    },

    submit() {
      if (!this.$refs.form.validate()) return

      this.$toast.success('Métrica adicionada com sucesso!')
      this.$emit('success', this.range)
    },
  },
}
</script>

<style></style>
